import React from 'react';
import cn from 'classnames';
export default function PaymentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: cn('icons', className),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#0040AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 15.0704H9.04651L10.0599 8.61691H11.6799L10.6667 15.0704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5398 8.77469C16.2202 8.64411 15.7134 8.49994 15.0866 8.49994C13.4867 8.49994 12.36 9.37867 12.3531 10.635C12.3398 11.5619 13.1598 12.0767 13.773 12.3858C14.3999 12.7016 14.6129 12.9077 14.6129 13.1892C14.6066 13.6216 14.1064 13.8209 13.64 13.8209C12.9931 13.8209 12.6466 13.7181 12.1199 13.4776L11.9065 13.3745L11.6798 14.8231C12.0598 15.0014 12.7599 15.1597 13.4867 15.1666C15.1867 15.1666 16.2934 14.3015 16.3065 12.9627C16.313 12.228 15.88 11.6651 14.9466 11.2051C14.3799 10.9098 14.0329 10.7107 14.0329 10.4086C14.0395 10.1339 14.3264 9.85262 14.9661 9.85262C15.4928 9.83884 15.8798 9.96923 16.1729 10.0997L16.3194 10.1682L16.5398 8.77469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6931 12.7842C18.8265 12.4134 19.3399 10.9785 19.3399 10.9785C19.3332 10.9923 19.4731 10.6009 19.5531 10.3607L19.6663 10.9168C19.6663 10.9168 19.9731 12.4615 20.0397 12.7842C19.7865 12.7842 19.0131 12.7842 18.6931 12.7842ZM20.6929 8.61691H19.4398C19.0533 8.61691 18.7597 8.73353 18.593 9.15236L16.1865 15.0703H17.8864C17.8864 15.0703 18.1663 14.2738 18.2265 14.1023C18.4129 14.1023 20.0667 14.1023 20.3066 14.1023C20.3531 14.3288 20.4999 15.0703 20.4999 15.0703H22L20.6929 8.61691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69334 8.61691L6.10669 13.0176L5.93331 12.1251C5.63997 11.0952 4.72 9.97634 3.69336 9.42L5.14667 15.0636H6.85993L9.40651 8.61691H7.69334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63331 8.61691H2.02667L2 8.74731C4.03335 9.28285 5.38 10.5738 5.93327 12.1254L5.36662 9.15939C5.27333 8.74722 4.98663 8.63051 4.63331 8.61691Z",
    fill: "white"
  })));
}